import React, { FC, useEffect, useState } from 'react'
import text from 'styles/utility/text.module.scss'
import { HorizontalLine, Spacer } from 'components/Utility'
import { useQueryLinkedUser } from 'hooks/coupon'
import classNames from 'classnames'
import { FlexRow } from 'components/Flex'
import { LightTag, GreyTag } from 'components/Tag'
import { OrangeButton } from 'components/Button'
import { db } from 'firebase/index'
import { CouponUserType } from 'types/coupon_user'

type Props = {
  addLinkedUser?: () => void
  couponId?: string
  couponUsers?: CouponUserType[]
  isAdded?: boolean
  status?: string
  uid: string
}

const CouponUserCard: FC<Props> = React.memo((props) => {
  const { addLinkedUser, couponId, couponUsers, isAdded, status, uid } = props
  const [_isAdded, setAdded] = useState(false)
  const user = useQueryLinkedUser(uid)
  const tag = (() => {
    switch (status) {
      case 'unused':
        return <GreyTag tagName={'配布済み'} />
      case 'used':
        return <GreyTag tagName={'使用済み'} />
      case 'linking':
        return <LightTag color={'blue'} label={'配布予定'} />
      default:
        return <></>
    }
  })()
  useEffect(() => {
    if (!couponId || !uid || !couponUsers || couponUsers.length < 10) return
    db.collection('coupons')
      .doc(couponId)
      .collection('coupon_users')
      .doc(uid)
      .get()
      .then((snapshot) => {
        setAdded(snapshot.exists)
      })
  }, [couponUsers, couponId, uid])

  useEffect(() => {
    setAdded(!!isAdded)
  }, [isAdded])

  return (
    <>
      <FlexRow justifyContent={'between'}>
        <div>
          <FlexRow justifyContent={'start'}>
            <p className={classNames(text.font_bold)}>氏名 : {user?.name}</p>
            <Spacer size={8} />
            {tag}
          </FlexRow>
          <Spacer size={12} />
          <p className={classNames(text.font_bold, text.wordBreakAll)}>ユーザーID : {uid}</p>
        </div>
        <Spacer size={8} />
        {addLinkedUser && (
          <OrangeButton disabled={_isAdded} label={'追加'} onClick={addLinkedUser} size={'xxsmall'} type={'main'} />
        )}
      </FlexRow>
      <Spacer size={12} />
      <HorizontalLine color={'grey04'} verticalMargin={0} />
    </>
  )
})

export default CouponUserCard
